export default "__VITE_ASSET__C2CDa4Uv__"